import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import Footer from "./Footer";
import TopBar from "./Topbar";

const InvestorWelcome = () => {
    const navigate = useNavigate();
    const [termsAccepted, setTermsAccepted] = useState(false);

    const handleNext = () => {
        if(!termsAccepted) {
            alert("Please accept the terms and conditions to continue.");
            return;
        }
        // Navigate to investor application
        navigate("/investor-application");
    };

    // Scroll to top on mount
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="flex flex-col bg-white">
            <TopBar />

            {/* Progress Bar */}
            <div className="bg-gray-100 p-4">
                <div className="max-w-6xl mx-auto">
                    <div className="flex justify-between items-center mb-2">
                        <span className="text-sm text-gray-600">
                            Step 1 of 5
                        </span>
                        <span className="text-sm text-gray-600">20%</span>
                    </div>
                    <div className="w-full bg-gray-300 rounded-full h-2">
                        <div
                            className="bg-navy h-2 rounded-full transition-all duration-300"
                            style={{ width: "20%" }}
                        ></div>
                    </div>
                </div>
            </div>

            <div className="flex-grow flex items-center justify-center py-8 px-4">
                <div className="max-w-6xl w-full">
                    <div className="flex flex-col lg:flex-row items-center gap-12">
                        {/* Left Content */}
                        <div className="flex-1 space-y-6">
                            <h1 className="text-4xl lg:text-5xl font-bold text-navy leading-tight">
                                Let&apos;s set up your investor account
                            </h1>

                            <div className="space-y-4 text-gray-700">
                                <p className="text-lg">
                                    By continuing, you agree to the{" "}
                                    <a
                                        href="/docs/terms_of_use_10_2026.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-navy underline hover:text-navy-2"
                                    >
                                        Terms
                                    </a>
                                    ,{" "}
                                    <a
                                        href="/docs/privacy_policy_10_2026.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-navy underline hover:text-navy-2"
                                    >
                                        Privacy Policy
                                    </a>
                                    ,{" "}
                                    <a
                                        href="/docs/investor_agreement_05_2026.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-navy underline hover:text-navy-2"
                                    >
                                        Investor Agreement
                                    </a>
                                    ,{" "}
                                    <a
                                        href="/docs/electronic_delivery_of_documents_11_2025.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-navy underline hover:text-navy-2"
                                    >
                                        Electronic Delivery of Documents
                                    </a>
                                     , and{" "}
                                    <a
                                        href="/docs/electronic_funds_transfers_03_2026.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-navy underline hover:text-navy-2"
                                    >
                                        Electronic Funds Transfers
                                    </a>
                                </p>

                                <div className="flex items-start space-x-3 mt-6">
                                    <input
                                        type="checkbox"
                                        id="terms-checkbox"
                                        checked={termsAccepted}
                                        onChange={(e) =>
                                            setTermsAccepted(e.target.checked)
                                        }
                                        className="mt-1 h-4 w-4 text-navy border-gray-300 rounded focus:ring-navy"
                                    />
                                    <label
                                        htmlFor="terms-checkbox"
                                        className="text-sm text-gray-700"
                                    >
                                        I have read and agree to the terms and
                                        conditions listed above.
                                    </label>
                                </div>

                                <div className="mt-6">
                                    <p className="text-sm text-gray-600 mb-2">
                                        Are you a founder raising money?
                                    </p>
                                    <a
                                        href="/sign-up"
                                        className="text-blue-600 underline hover:text-blue-800 text-sm"
                                    >
                                        Start a campaign
                                    </a>
                                    <span className="text-sm text-gray-600">
                                        {" "}
                                        instead.
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Right Content - AQi Logo */}
                        <div className="flex-1 flex justify-center items-center">
                            <div className="relative w-full max-w-md h-80 flex items-center justify-center bg-white rounded-lg">
                                <img
                                    src="/images/Logo_for_flow.png"
                                    alt="AQi Logo"
                                    className="h-48 w-auto object-contain"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Next Button */}
                    <div className="flex justify-end mt-12">
                        <button
                            onClick={handleNext}
                            disabled={!termsAccepted}
                            className={`px-8 py-3 rounded-lg font-medium transition-colors ${
                                termsAccepted
                                    ? "bg-navy text-white hover:bg-navy-2"
                                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                            }`}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default InvestorWelcome;
